export const saveFromRoute = (v) => {
	sessionStorage.setItem('GXXT_FROM_ROUTER', v)
};

export const getFromRoute = () => {
	return sessionStorage.getItem('GXXT_FROM_ROUTER')
};

export const setShareInfo = (v) => {
	sessionStorage.setItem('GXXT_SHARE_INFO', JSON.stringify(v))
};

export const getShareInfo = () => {
	return JSON.parse(sessionStorage.getItem('GXXT_SHARE_INFO'))
};

export const saveUserInfo = (v) => {
	localStorage.setItem('GXXT_USER_INFO', JSON.stringify(v))
}

export const getUserInfo = () => {
	let v = localStorage.getItem('GXXT_USER_INFO')
	if (v) {
		return JSON.parse(localStorage.getItem('GXXT_USER_INFO'))
	} else {
		return {}
	}
}
